import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"
import FormUpload from "components/FormUpload"
// import Rating from "react-rating-tooltip"
import Rating from "react-rating"
import { getOrderPrefix } from "helpers/common_helper"
import axios from "axios"
import SweetAlert from "react-bootstrap-sweetalert"
import { updateOrderSuccess } from "store/actions"
import { post } from "helpers/api_helper"
// import { createSelector } from "reselect";
// import img7 from "../../../assets/images/product/img-7.png"
// import img4 from "../../../assets/images/product/img-4.png"

const OrderOrdersModal = props => {
  const API_URL = `${window.APP_CONFIG.BASE_URL}/`;
  const { isOpen, toggle, processData } = props

  const dispatch = useDispatch();

  const [title, setTitle] = useState("")
  const [order, setOrder] = useState(processData || null)
  const [alert, setAlert] = useState(null);
  const [submitRes, setSubmitRes] = useState(null);

  //meta title
  document.title = "Orders | Process form"

  const [saving, setSaving] = useState(false); // NEW
  const [sendEmail, setSendEmail] = useState(false);
  const [requestFor, setRequestFor] = useState(""); // NEW
  const [files, setFiles] = useState([]) // Add state for files
  const [firebaseFiles, setFirebaseFile] = useState([]) // Add state for files

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      stitiches: (order && order.stitiches) || "",
      price: (order && +order.price) || "",
      discount: (order && order.discount) || "",
      totalPrice: (order && order.totalPrice) || "",
      orderCatagory: (order && order.orderCatagory) || false,
      height: (order && order.height) || 0,
      width: (order && order.width) || 0,
      comments: (order && order.comments) || "",
      requestFor: processData?.requestFor,
      modelFor: processData?.orderCode,
      selectLevel: (order && order.selectLevel) || "",
      assignPercentage: (order && order.assignPercentage) || 0,
      // uploadedFiles: []
    },
    validationSchema: Yup.object({
      stitiches: Yup.string()
        .max(50, "Comments can't be more than 50 characters"),
      // .required("stitiches is required"),

      price: Yup.number()
        .typeError("Price must be a number")
        .positive("Price must be greater than zero")
        .required("Price is required"),

      discount: Yup.number()
        .typeError("Discount must be a number")
        .min(0, "Discount cannot be negative")
        .test("is-less-than-price", "Discount must be less than Price", function (value) {
          const { price } = this.parent;
          if (price === undefined || price === null) return true; // skip if no price yet
          return value < price; // must be strictly less
        }),
      // .required("Discount is required"),

      // totalPrice: Yup.number()
      //   .typeError("Total Price must be a number")
      //   .min(0, "Total Price must be zero or more")
      //   .required("Total Price is required"),

      orderCatagory: Yup.boolean(),

      height: Yup.number()
        .typeError("Height must be a number")
        .min(0, "Height must be at least 0"),
      // .required("Height is required"),

      width: Yup.number()
        .typeError("Width must be a number")
        .min(0, "Width must be at least 0"),
      // .required("Width is required"),

      comments: Yup.string()
        .max(500, "Comments can't be more than 500 characters"),
      // .required("Comments are required"),


      selectLevel: Yup.number()
        .typeError("Select Level must be a number")
        .min(1, "Select Level must be between 1 and 10")
        .max(10, "Select Level must be between 1 and 10"),
      //  .required("Select Level is required"),

      assignPercentage: Yup.number()
        .typeError("Assign Percentage must be a number")
        .min(0, "Rating must be 0 or more")
        .max(5, "Rating must be 5 or less")
      // .required("Assign Percentage (Rating) is required"),
    }),
    onSubmit: async (values) => {

      const totalPrice = (values.price || 0) - (values.discount || 0);

      values.totalPrice = totalPrice;
      values.orderStatus = "Ready"
      // values.sentDate = new Date();

      if (Object.keys(firebaseFiles).length > 0) {
        // If new files uploaded → overwrite
        values.imagesUploads = Object.entries(firebaseFiles).map(([name, url]) => ({
          imageName: name,
          filePath: url,
          status: "success",
        }));
      } else {
        // Otherwise keep existing files
        values.imagesUploads = order?.imagesUploads || [];
      }


      setSaving(true)
      // await axios.post(`${process.env.REACT_APP_BASE_URL}/processing`, values).then(res => {
      await post("/processing", values).then(res => {
        setSubmitRes(res.order)
        dispatch(updateOrderSuccess(res.order))
        setAlert(
          <SweetAlert
            success
            title="Order Successful!"
            confirmBtnText="OK"
            onConfirm={() => { setAlert(null); toggle() }}
            onCancel={() => { setAlert(null); toggle() }}
          >
            <p>Your order has been placed successfully. Your Order No is {res.order.orderCode}</p>
          </SweetAlert>
        );

      }).catch(err => console.error("Error saving order processing data:", err));
      setSaving(false)

    },
  })

  useEffect(() => {
    if (isOpen != false) {
      setTitle(getOrderPrefix(order.requestFor) + order.orderCode + " - " + order.userName)
      setRequestFor(order.requestFor);
      setOrder("processingData" in processData ? processData.processingData : {})
    }
  }, [isOpen])



  // Function to handle file changes from FormUpload component
  const handleFileChange = (acceptedFiles) => {
    // setFiles(acceptedFiles);
    // validation.setFieldValue('uploadedFiles', acceptedFiles);
  }
  const handleUpload = (downloadURL, name) => {
    // You can handle the uploaded file URL here if needed
    setFirebaseFile(prev => ({ ...prev, [name]: downloadURL }));

  }

  const haandleSendingRecord = async () => {
    const payload = saving || processData;
    payload.sentDate = new Date();

    setSendEmail(true)
    // const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/processing-email`, payload).then(res => {
    const response = await post("/processing-email", payload).then(res => {
      // alert("Order processing data saved successfully!");
      dispatch(updateOrderSuccess(payload))
      setAlert(
        <SweetAlert
          success
          title="Email Sent Successful!"
          confirmBtnText="OK"
          onConfirm={() => { setAlert(null), toggle(); }}
        >
          <p>Email Successfully Sent For Order No {res.data.orderCode}</p>
        </SweetAlert>
      );
      setSendEmail(false)
    }).catch(err => console.error("Error saving order processing data:", err));

  }

  const onUploadStatusChange = () => {
    return null
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={toggle}
        size="lg"
      >

        <ModalHeader toggle={toggle} tag="h4">
          {title}
          {/* {!!isEdit ? "Edit Order" : "Add Order"} */}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              
              return false
            }}
          >

            <Row>
              <Col className="col-12">
                {/* stitiches */}
                {requestFor != "vector" ? (
                  <Row>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label>stitiches</Label>
                        <Input
                          name="stitiches"
                          type="text"
                          placeholder="Insert stitiches"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.stitiches || ""}
                          invalid={validation.touched.stitiches && validation.errors.stitiches ? true : false}
                        />
                        {validation.touched.stitiches && validation.errors.stitiches ? (
                          <FormFeedback type="invalid">{validation.errors.stitiches}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={4}>
                      {/* Height */}
                      <div className="mb-3">
                        <Label>Height</Label>
                        <Input
                          name="height"
                          type="number"
                          step="0.01"
                          placeholder="Enter height"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.height || ""}
                          invalid={
                            validation.touched.height && validation.errors.height ? true : false
                          }
                        />
                        {validation.touched.height && validation.errors.height ? (
                          <FormFeedback type="invalid">{validation.errors.height}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={4}>
                      {/* Width */}
                      <div className="mb-3">
                        <Label>Width</Label>
                        <Input
                          name="width"
                          type="number"
                          step="0.01"
                          placeholder="Enter width"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.width || ""}
                          invalid={
                            validation.touched.width && validation.errors.width ? true : false
                          }
                        />
                        {validation.touched.width && validation.errors.width ? (
                          <FormFeedback type="invalid">{validation.errors.width}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                ) : ""}
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label>Price</Label>
                      <Input
                        name="price"
                        type="number"
                        placeholder="Insert Price"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.price || ""}
                        invalid={validation.touched.price && validation.errors.price ? true : false}
                      />
                      {validation.touched.price && validation.errors.price ? (
                        <FormFeedback type="invalid">{validation.errors.price}</FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={4}>
                    {/* Discount */}
                    <div className="mb-3">
                      <Label>Discount</Label>
                      <Input
                        name="discount"
                        type="number"
                        placeholder="Enter discount"
                        step="0.01"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.discount || ""}
                        invalid={
                          validation.touched.discount && validation.errors.discount ? true : false
                        }
                      />
                      {validation.touched.discount && validation.errors.discount ? (
                        <FormFeedback type="invalid">{validation.errors.discount}</FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={4}>
                    {/* Total Price */}
                    <div className="mb-3">
                      <Label>Total Price</Label>
                      <Input
                        // name="totalPrice"
                        type="number"
                        placeholder="Enter total price"
                        step="0.01"
                        disabled
                        // onChange={validation.handleChange}
                        // onBlur={validation.handleBlur}
                        value={validation.values.price - validation.values.discount}
                      // invalid={
                      //   validation.touched.totalPrice && validation.errors.totalPrice ? true : false
                      // }
                      />

                    </div>
                  </Col>

                </Row>
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label>Select Level</Label>
                      <Input
                        type="select"
                        name="selectLevel"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.selectLevel || ""}
                        invalid={
                          validation.touched.selectLevel && validation.errors.selectLevel
                            ? true
                            : false
                        }
                      >
                        <option value="">Select Level</option>
                        {[...Array(10)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </Input>
                      {validation.touched.selectLevel && validation.errors.selectLevel ? (
                        <FormFeedback type="invalid">{validation.errors.selectLevel}</FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label>Order Category</Label>
                      <div className="form-check">
                        <Input
                          type="checkbox"
                          name="orderCatagory"
                          id="orderCatagory"
                          onChange={() => { validation.setFieldValue("orderCatagory", !validation.values.orderCatagory) }}
                          onBlur={validation.handleBlur}
                        />
                        <label className="form-check-label" htmlFor="orderCatagory">
                          Free Order
                        </label>
                      </div>
                      {validation.touched.orderCatagory && validation.errors.orderCatagory ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.orderCatagory}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={4}>
                    {/* Assign Percentage (Stars) */}
                    <div className="mb-3">
                      <Label>Assign Percentage</Label>
                      <Rating
                        size={25}
                        initialRating={validation.values.assignPercentage}
                        // initialValue={validation.values.assignPercentage || 0}
                        // onChange={(rate) => {validation.setFieldValue("assignPercentage", rate)}}
                        onClick={(rate) => { validation.setFieldValue("assignPercentage", rate) }}
                      />
                      {validation.touched.assignPercentage &&
                        validation.errors.assignPercentage ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.assignPercentage}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                </Row>


                {/* Comments */}
                <div className="mb-3">
                  <Label>Comments</Label>
                  <Input
                    name="comments"
                    type="textarea"
                    rows="3"
                    placeholder="Enter comments"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.comments || ""}
                    invalid={
                      validation.touched.comments && validation.errors.comments ? true : false
                    }
                  />
                  {validation.touched.comments && validation.errors.comments ? (
                    <FormFeedback type="invalid">{validation.errors.comments}</FormFeedback>
                  ) : null}
                </div>
              </Col>

            </Row>
            {/* <Row>
            <Col className="col-12">

            { "imagesUploads" in order ? order.imagesUploads.map((item, i) => {return(
            <div key={i}><img src="https://embexpart-eac4f.web.app/assets/images/imgIcon.jpg" width={50}/></div>
            )}): ""}
            </Col>
          </Row> */}
            <Row>
              <Col className="col-12">
                <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
                  {"imagesUploads" in order && order.imagesUploads?.map((item, i) => (
                    <div key={i} className="text-center" style={{ width: "100px", cursor: "pointer" }}

                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title={item.imageName || `Image ${i + 1}`}

                    >
                      <a href={item.filePath} target="_blank" rel="noopener noreferrer">
                        <div className="border p-1 mb-1">
                          <img
                            src={item.url || "/file.jpg"}
                            width={50}
                            height={50}
                            alt={`Upload ${i}`}
                            className="img-thumbnail d-block mx-auto"

                            onError={(e) => {
                              e.target.src = "/file.jpg";
                            }}
                          />
                        </div>
                        <div
                          className="text-truncate small position-relative"

                        >
                          {item.imageName || `Image ${i + 1}`}
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="col-12">
                <FormUpload onUploadStatusChange={onUploadStatusChange} onFileChange={handleFileChange} handleUpload={handleUpload} orderCode={processData ? processData.orderCode : 0} fileLimit={10} />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end ">
                  {/* disabled={processData.orderStatus !== "New" ? true: false} */}
                  <Button color="primary" type="submit" className="save-order mx-2" >
                    {saving ? "Saving..." : "Save Record"}
                  </Button>

                  <Button color="success mx-2" onClick={() => haandleSendingRecord()} disabled={submitRes || processData.orderStatus === "New" || sendEmail ? true : false}>
                    {sendEmail ? "Sending..." : "Send Record"}
                  </Button>

                  <Button color="secondary mx-2" onClick={toggle} >
                    Close
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>

      </Modal>
      {alert}
    </>

  )
}

OrderOrdersModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  processData: PropTypes.object,
}

export default OrderOrdersModal
